/**
 * What `createSupabaseClient` knows that a request going AROUND the client
 * needs: the 401 retry rule's own state (the shared refresh, the cooldown, the
 * session's remembered tokens) and the functions address. Kept per client, so a
 * helper handed a client uses that client's rule, never a second copy of it.
 */
export interface SessionTools {
  /** A plain function, never a method: it is handed around unbound. */
  retryToken: (sent: string) => Promise<string | null>;
  functionsUrl: string;
  anonKey: string;
}

const tools = new WeakMap<object, SessionTools>();

export function registerSessionTools(client: object, value: SessionTools): void {
  tools.set(client, value);
}

/** Throws for a client this package did not build: it has no retry rule to share. */
export function sessionToolsOf(client: object): SessionTools {
  const found = tools.get(client);
  if (found === undefined) {
    throw new Error(
      'This Supabase client was not built by createSupabaseClient, so it has no shared ' +
        'sign-in retry or functions address.',
    );
  }
  return found;
}
